export enum CycleStatusEnum {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  PROCESSING_ERROR = "PROCESSING_ERROR",
  PROCESSING_DELEGATION_ERROR = "PROCESSING_DELEGATION_ERROR",
  PROCESSING_PAYMENT = "PROCESSING_PAYMENT",
  WAITING_AUTHORIZATION_PIX_AUTO = "WAITING_AUTHORIZATION_PIX_AUTO",
  PAYMENT_ERROR = "PAYMENT_ERROR",
  PAST_DUE = "PAST_DUE",
  PAID = "PAID",
  CANCELED = "CANCELED",
  REFUNDED = "REFUNDED",
  PARTIAL_REFUNDED = "PARTIAL_REFUNDED",
  REVERSED = "REVERSED",
  PROCESSING_REFUNDING = "PROCESSING_REFUNDING",
  PROCESSING_REVERSING = "PROCESSING_REVERSING",
  REFUND_FAILED = "REFUND_FAILED",
  REVERSED_FAILED = "REVERSED_FAILED",
  PAYMENT_DENIED = "PAYMENT_DENIED",
  UPDATED = "UPDATED",
  PROCESSING_DELEGATION = "PROCESSING_DELEGATION",
  CANCELED_BY_DELEGATE_UPDATE = "CANCELED_BY_DELEGATE_UPDATE",
  CANCELED_BY_AMOUNT_UPDATE = "CANCELED_BY_AMOUNT_UPDATE",
  SCHEDULED_RETRY = "SCHEDULED_RETRY",
}
export const SubscriptionStatusColorsEnum: Record<
  string,
  string
> = {
  // ✅ Sucesso - Verde
  FINISHED: "#4caf50",
  REVIEW_APPROVED: "#4caf50",

  // 🔵 Criado - Azul
  CREATED: "#2196f3",

  // 🟡 Em progresso - Amarelo
  IN_PROGRESS: "#ffc107",

  // 🟠 Alerta/Análise - Laranja
  PAST_DUE: "#ff9800",
  UNDER_REVIEW: "#ff9800",
  SCHEDULED_RETRY: "ff9800",

  // 🟤 Expirado - Âmbar escuro
  EXPIRED: "#ff6f00",
  REVIEW_EXPIRED: "#ff6f00",

  // ❌ Rejeitado - Vermelho
  REVIEW_REJECTED: "#f44336",

  // ⚫ Cancelado - Cinza escuro
  CANCELED: "#f44336",
} as const

export const CycleStatusColorsEnum: Record<string, string> =
  {
    // ✅ Sucesso - Verde
    PAID: "#4caf50",

    // ❌ Erro/Negado/Cancelado - Vermelho
    PROCESSING_ERROR: "#f44336",
    PROCESSING_DELEGATION_ERROR: "#f44336",
    PAYMENT_ERROR: "#f44336",
    PAYMENT_DENIED: "#f44336",
    CANCELED: "#f44336",
    CANCELED_BY_DELEGATE_UPDATE: "#f44336",
    CANCELED_BY_AMOUNT_UPDATE: "#f44336",

    // ⚪ Processamento de reversão - Cinza claro
    PROCESSING_REFUNDING: "#9e9e9e",
    PROCESSING_REVERSING: "#9e9e9e",

    // 🟡 Falha de estorno - Âmbar. NÃO é vermelho: o dinheiro segue com o
    // lojista, o ciclo volta a PAID e a operação pode ser tentada de novo.
    REFUND_FAILED: "#ff9800",
    REVERSED_FAILED: "#ff9800",

    // 🟣 Reembolso/Estorno - Roxo
    REFUNDED: "#9c27b0",
    REVERSED: "#9c27b0",

    // 🟠 Pendente/Parcial/Vencido - Laranja
    PENDING: "#ff9800",
    PARTIAL_REFUNDED: "#ff9800",
    PAST_DUE: "#ff9800",

    // 🟡 Processamento - Amarelo
    PROCESSING: "#ffc107",
    PROCESSING_PAYMENT: "#ffc107",
    WAITING_AUTHORIZATION_PIX_AUTO: "#ffc107",
    PROCESSING_DELEGATION: "#ffc107",

    // 🔵 Atualizado - Azul
    UPDATED: "#2196f3",

    // Retentativa repic
    SCHEDULED_RETRY: "#757575",
  } as const

export const cycleStatusLabels: Record<
  CycleStatusEnum,
  string
> = {
  [CycleStatusEnum.PENDING]:
    "subscriptions.cycleStatus.pending",
  [CycleStatusEnum.PROCESSING]:
    "subscriptions.cycleStatus.processing",
  [CycleStatusEnum.PROCESSING_ERROR]:
    "subscriptions.cycleStatus.processingError",
  [CycleStatusEnum.PROCESSING_DELEGATION_ERROR]:
    "subscriptions.cycleStatus.processingDelegationError",
  [CycleStatusEnum.PROCESSING_PAYMENT]:
    "subscriptions.cycleStatus.processingPayment",
  [CycleStatusEnum.WAITING_AUTHORIZATION_PIX_AUTO]:
    "subscriptions.cycleStatus.waitingAuthorizationPixAuto",
  [CycleStatusEnum.PAYMENT_ERROR]:
    "subscriptions.cycleStatus.paymentError",
  [CycleStatusEnum.PAST_DUE]:
    "subscriptions.cycleStatus.pastDue",
  [CycleStatusEnum.PAID]: "subscriptions.cycleStatus.paid",
  [CycleStatusEnum.CANCELED]:
    "subscriptions.cycleStatus.canceled",
  [CycleStatusEnum.REFUNDED]:
    "subscriptions.cycleStatus.refunded",
  [CycleStatusEnum.PARTIAL_REFUNDED]:
    "subscriptions.cycleStatus.partialRefunded",
  [CycleStatusEnum.REVERSED]:
    "subscriptions.cycleStatus.reversed",
  [CycleStatusEnum.PROCESSING_REFUNDING]:
    "subscriptions.cycleStatus.processingRefunding",
  [CycleStatusEnum.PROCESSING_REVERSING]:
    "subscriptions.cycleStatus.processingReversing",
  [CycleStatusEnum.REFUND_FAILED]:
    "subscriptions.cycleStatus.refundFailed",
  [CycleStatusEnum.REVERSED_FAILED]:
    "subscriptions.cycleStatus.reversedFailed",
  [CycleStatusEnum.PAYMENT_DENIED]:
    "subscriptions.cycleStatus.paymentDenied",
  [CycleStatusEnum.UPDATED]:
    "subscriptions.cycleStatus.updated",
  [CycleStatusEnum.PROCESSING_DELEGATION]:
    "subscriptions.cycleStatus.processingDelegation",
  [CycleStatusEnum.CANCELED_BY_DELEGATE_UPDATE]:
    "subscriptions.cycleStatus.canceledByDelegateUpdate",
  [CycleStatusEnum.CANCELED_BY_AMOUNT_UPDATE]:
    "subscriptions.cycleStatus.canceledByAmountUpdate",
  [CycleStatusEnum.SCHEDULED_RETRY]:
    "subscriptions.cycleStatus.scheduledRetry",
}
export enum RecurringUnitEnum {
  DAY = "DAY",
  MONTH = "MONTH",
  YEAR = "YEAR",
  CUSTOM = "CUSTOM",
  CYCLES = "CYCLES",
}
export const recurringUnitLabels: Record<
  RecurringUnitEnum,
  string
> = {
  [RecurringUnitEnum.DAY]: "recurringUnit.day",
  [RecurringUnitEnum.MONTH]: "recurringUnit.month",
  [RecurringUnitEnum.YEAR]: "recurringUnit.year",
  [RecurringUnitEnum.CUSTOM]: "recurringUnit.custom",
  [RecurringUnitEnum.CYCLES]: "recurringUnit.cycles",
}
export enum SubscriptionTypeEnum {
  INSURANCE = "INSURANCE",
  VTEX = "VTEX",
  GENERIC = "GENERIC",
}
export const subscriptionTypeLabels: Record<
  SubscriptionTypeEnum,
  string
> = {
  [SubscriptionTypeEnum.INSURANCE]:
    "subscriptionType.insurance",
  [SubscriptionTypeEnum.VTEX]: "subscriptionType.vtex",
  [SubscriptionTypeEnum.GENERIC]:
    "subscriptionType.generic",
}
export enum SubscriptionStatusEnum {
  CREATED = "CREATED",
  UNDER_REVIEW = "UNDER_REVIEW",
  REVIEW_APPROVED = "REVIEW_APPROVED",
  REVIEW_REJECTED = "REVIEW_REJECTED",
  REVIEW_EXPIRED = "REVIEW_EXPIRED",
  IN_PROGRESS = "IN_PROGRESS",
  PAST_DUE = "PAST_DUE",
  EXPIRED = "EXPIRED",
  CANCELED = "CANCELED",
  FINISHED = "FINISHED",
  SCHEDULED_RETRY = "SCHEDULED_RETRY",
}
export const subscriptionStatusLabels: Record<
  SubscriptionStatusEnum,
  string
> = {
  [SubscriptionStatusEnum.CREATED]:
    "subscriptions.status.CREATED",
  [SubscriptionStatusEnum.UNDER_REVIEW]:
    "subscriptions.status.UNDER_REVIEW",
  [SubscriptionStatusEnum.REVIEW_APPROVED]:
    "subscriptions.status.REVIEW_APPROVED",
  [SubscriptionStatusEnum.REVIEW_REJECTED]:
    "subscriptions.status.REVIEW_REJECTED",
  [SubscriptionStatusEnum.REVIEW_EXPIRED]:
    "subscriptions.status.REVIEW_EXPIRED",
  [SubscriptionStatusEnum.IN_PROGRESS]:
    "subscriptions.status.IN_PROGRESS",
  [SubscriptionStatusEnum.PAST_DUE]:
    "subscriptions.status.PAST_DUE",
  [SubscriptionStatusEnum.EXPIRED]:
    "subscriptions.status.EXPIRED",
  [SubscriptionStatusEnum.CANCELED]:
    "subscriptions.status.CANCELED",
  [SubscriptionStatusEnum.FINISHED]:
    "subscriptions.status.FINISHED",
  [SubscriptionStatusEnum.SCHEDULED_RETRY]:
    "subscriptions.status.SCHEDULED_RETRY",
}
